import { render, staticRenderFns } from "./cancelDialog.vue?vue&type=template&id=2f60114c&scoped=true&"
import script from "./cancelDialog.vue?vue&type=script&lang=js&"
export * from "./cancelDialog.vue?vue&type=script&lang=js&"
import style0 from "./cancelDialog.vue?vue&type=style&index=0&id=2f60114c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60114c",
  null
  
)

export default component.exports